/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface AssignCustomerToContactRequest
 */
export interface AssignCustomerToContactRequest {
    /**
     * 
     * @type {number}
     * @memberof AssignCustomerToContactRequest
     */
    customerId?: number;
}

/**
 * Check if a given object implements the AssignCustomerToContactRequest interface.
 */
export function instanceOfAssignCustomerToContactRequest(value: object): boolean {
    return true;
}

export function AssignCustomerToContactRequestFromJSON(json: any): AssignCustomerToContactRequest {
    return AssignCustomerToContactRequestFromJSONTyped(json, false);
}

export function AssignCustomerToContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignCustomerToContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
    };
}

export function AssignCustomerToContactRequestToJSON(value?: AssignCustomerToContactRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'customerId': value['customerId'],
    };
}

